import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import styled from "styled-components";
import { Grid, Section, BreadCrumbBox, Typography, Loading } from "../../core";
import YarnDetail from "./ProgramDetails/YarnDetail";
import BeamInOutDetail from "./ProgramDetails/BeamInOutDetail";
import { theme, MixStyle, media } from "../../styles";
import { useParams } from "react-router-dom";
import { getProgramById } from "../../helper/utils/api/sizer";
import { getCompanyId } from "../../helper/utils/companyId";

const { textColor } = theme;

const Container = styled.div`
  .amount--label {
    font-weight: 500;
    font-size: 36px;
    line-height: 54px;
    color: #404e67;
  }
  .rs--badge {
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    color: #404e67;
  }
`;

const TypoProps = {
  label: {
    as: "h5",
    weight: "500",
    color: textColor.primary,
  },
  value: {
    as: "h3",
    color: " #6789C5",
  },
};

const Wraper = styled.div`
  margin-top: 20px;
  padding: 20px 0px;
  .general-info {
    ${MixStyle.flexBetween};
    ${media.tablet`display:block;`};
    flex-flow: row wrap;
    > div {
      max-width: 100%;
      width: 50%;
      display: flex;
      align-items: center;
      ${MixStyle.flexStart};
      ${media.tablet`justify-content: space-between;width:100%;`}
    }
  }
`;

const ProgramDetail = () => {
  const { programId } = useParams();
  const [program, setProgram] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      const companyId = getCompanyId();
      if (!programId || !companyId) return;
      setIsLoading(true);
      try {
        const { data } = await getProgramById(programId, companyId);
        const raw = data?.result || data;
        setProgram(Array.isArray(raw) ? raw[0] : raw);
      } catch (error) {
        console.log("program detail error", error);
        setProgram(null);
      }
      setIsLoading(false);
    };
    load();
  }, [programId]);

  if (isLoading) return <Loading />;
  if (!program) {
    return (
      <Grid>
        <BreadCrumbBox tittle="Program Details" />
        <Section padding="20px">
          <Typography text="Program not found" as="h3" />
        </Section>
      </Grid>
    );
  }

  const beamDelivery = program.beam_delivery_dates || program.empty_beam_dates || [];
  const beamReceived = program.beam_received_dates || program.beam_received || [];

  return (
    <Container>
      <Grid>
        <BreadCrumbBox tittle="Program Details" />
        <Section padding="20px">
          <Row type="flex" justify="space-between">
            <Typography
              noMargin
              as="h2"
              weight="bold"
              color="#404E67"
              letterSpacing="0.2"
              text={program.sizer_name || "Sizer"}
            />
            <Typography
              noMargin
              as="h2"
              weight="bold"
              color=" #FE5687"
              letterSpacing="0.2"
            >
              <span className="amount--label">Amount: </span>
              <span className="rs--badge">Rs</span>
              {program.ammount || program.amount || program.rate || 0}
            </Typography>
          </Row>
        </Section>
        <Section className="mt-20 mb-50" padding="30px">
          <Wraper>
            <Typography as="h3" weight="bold" color="#404E67">
              Program Requirement:
            </Typography>
            <div className="general-info d-flex v-center">
              <div>
                <Typography {...TypoProps.label} text="Tar : " />
                <Typography {...TypoProps.value} text={program.tar || "-"} />
              </div>
              <div>
                <Typography {...TypoProps.label} text="Beam Size " />
                <Typography
                  {...TypoProps.value}
                  text={program.beam_size || program.back_beam || "-"}
                />
              </div>
              <div>
                <Typography {...TypoProps.label} text="Quality : " />
                <Typography {...TypoProps.value} text={program.quality || "-"} />
              </div>
              <div>
                <Typography {...TypoProps.label} text="Final Beam : " />
                <Typography
                  {...TypoProps.value}
                  text={program.final_beam || program.quantity || "-"}
                />
              </div>
              <div>
                <Typography {...TypoProps.label} text="Back Beam : " />
                <Typography
                  {...TypoProps.value}
                  text={program.back_beam || "-"}
                />
              </div>
            </div>
          </Wraper>
          <div>
            <Typography as="h3" weight="600" color="#404E67">
              Yarn Detail
            </Typography>
            <YarnDetail rows={[program]} />
          </div>
          <div className="mt-30">
            <Row type="flex" justify="space-between" gutter={[16, 16]}>
              <Col md={12}>
                <Typography as="h3" weight="600" color="#404E67">
                  Empty Beam Delivery Date
                </Typography>
                <BeamInOutDetail
                  data={
                    Array.isArray(beamDelivery) && beamDelivery.length
                      ? beamDelivery
                      : []
                  }
                />
              </Col>
              <Col md={12}>
                <Typography as="h3" weight="600" color="#404E67">
                  Beam Received Date
                </Typography>
                <BeamInOutDetail
                  data={
                    Array.isArray(beamReceived) && beamReceived.length
                      ? beamReceived
                      : []
                  }
                />
              </Col>
            </Row>
          </div>
        </Section>
      </Grid>
    </Container>
  );
};

export default ProgramDetail;
